import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section id="top" className="flex min-h-[calc(100svh-3.75rem)] bg-brand-main px-4 py-7 text-center sm:py-8" data-id="element-95" data-mp="2hvm4m8t8rmbp">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex w-full max-w-4xl flex-col items-center justify-center" data-id="element-96" data-mp="23wmhx6pahhi6">
        <p className="mb-2 inline-flex rounded-full bg-brand-green/12 px-3 py-1 text-[10px] font-extrabold tracking-[0.18em] text-brand-green sm:text-xs" data-id="element-97" data-mp="30lu0q6yixcie">
          PRIMARIA E SECONDARIA · ETÀ 6-14 ANNI
        </p>
        <h1 className="mx-auto max-w-5xl text-[2.05rem] font-extrabold leading-[1.06] tracking-tight text-brand-blue sm:text-[3.2rem] md:text-[3.55rem]" data-id="element-98" data-mp="2rryvz01bdo3a">
          Insegna un Anno Intero di <span className="italic text-brand-red" data-id="element-99" data-mp="3k9tezrsar1sk">Arte</span> in Soli 5 Minuti di
          Preparazione
        </h1>
        <p className="mx-auto mt-3 max-w-3xl text-sm leading-relaxed text-brand-gray sm:text-base md:text-lg" data-id="element-100" data-mp="2fgk08zrodqpp">
          ARTE PRONTA™ è il curricolo artistico completo, pronto all&apos;uso, per la scuola primaria e secondaria
          italiana. 8 volumi, 64 unità didattiche, zero ore spese a preparare le lezioni da zero.
        </p>
        <img src="https://cdn.magicpatterns.com/uploads/qUU6MG7S7WpKYN7XkC7Tqx/Mockup-Photoroom.png" alt="Il pacchetto ARTE PRONTA: gli 8 volumi dalla 1ª primaria alla 3ª media, i materiali digitali e i 5 bonus inclusi" className="mx-auto my-2 h-[36svh] w-auto max-w-full object-contain sm:my-3 sm:h-[39svh] md:h-[42svh]" data-id="element-101" data-mp="2kdaav7kpnu3q" />
        <div className="flex w-full flex-col items-center" data-id="element-102" data-mp="3365wpfgnxru0">
          <CTAButton className="min-w-[204px] px-4 py-2.5 text-[10px] shadow-sm sm:min-w-[236px] sm:px-5 sm:py-3 sm:text-[11px]" data-id="element-103" data-mp="1dq6jnn9xbi93">
            OTTIENI ARTE PRONTA™ ORA
          </CTAButton>
          <p className="mt-2 max-w-xl text-center text-[9px] font-semibold leading-relaxed text-brand-gray sm:text-[10px]" data-id="element-104" data-mp="18tg4r39uusp9">
            ✓ Pagamento unico <span className="px-1 text-brand-ochre" data-id="element-105" data-mp="3drmlc5i94n7s">·</span> ✓ Accesso immediato
            <span className="px-1 text-brand-ochre" data-id="element-106" data-mp="3irr3dzyt5q04">·</span> ✓ Pronto da stampare
          </p>
        </div>
      </motion.div>
    </section>;
}